import { Box } from "@mui/material";
import { OutlinedInput, InputLabel, Typography, FormHelperText } from "@mui/material";
import Export from '../../assets/export.svg'
import { withTheme } from "@emotion/react";
// UNCOMMENT IF YOU INTEND USING "LoadedState"
// import PDF from '../../assets/pdf.svg'
// import {IconButton} from "@mui/material";
// import CloseIcon from '@mui/icons-material/Close';

const FileInput = (props) => {


    const theme = props.theme
    // UNCOMMENT IF YOU INTEND USING "LoadedState"
    // const LoadedState = () => {
    //    return(<Stack alignItems={'center'} width={{ xs: 'auto', md: '300px', }} padding={'8px 24px'} gap={'8px'}  marginTop='8px' direction={'row'}>
    //         <img src={PDF} />
    //         <Typography fontSize={'12px'}>{'Employment Info.pdf'}</Typography>
    //         <IconButton color="#292727" size="small" aria-label="close">
    //             <CloseIcon fontSize="small" />
    //         </IconButton>
    //     </Stack>
    //    )
    // }
    return (

        <Box sx={{ width: { xs: '100%', md: 'auto' } }} variant="outlined">
            {props.fileLable && <FormHelperText sx={{ ...theme.typography.inputTitle, color: '#292727' }} id="my-helper-text">{props.fileLable}</FormHelperText>}
            {/* <LoadedState/> */}
            <InputLabel sx={{
                display: 'flex',
                gap: '8px',
                padding: '14px 24px',
                borderRadius: '8px',
                border: '1px solid #EDF5FF',
                justifyContent: 'center',
                width: { xs: 'auto', md: '133px', },
                marginTop: '8px'
            }}
                htmlFor="outlined-adornment-weight"
            >
                {props.showImage && <img src={Export} alt="upload icon" />}
                <Typography sx={{ ...theme.typography.button, color: '#1E87FF' }}>{props.title}</Typography>
            </InputLabel>
            <OutlinedInput
                type="file"
                id="outlined-adornment-weight"
                aria-describedby="outlined-weight-helper-text"
                inputProps={{
                    'aria-label': 'file input',
                }}
                sx={{ display: 'none' }}
            /> 
        </Box>
    )
}

export default withTheme(FileInput)